import React, { useId } from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
import { browseMessages as messages } from '../browseMessages';
import { BROWSE_SERVICE_OPTIONS } from './browseServiceOptions';
/* eslint-disable css-modules/no-unused-class -- a shared stylesheet; each part uses its own slice of it */
import styles from './BrowseSearch.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface BrowseServiceSelectProps {
  value: string | undefined;
  onChange: (service: string | undefined) => void;
}

/** The Service filter of a Label workspace (design a1). "All" clears it. */
const BrowseServiceSelectComponent: React.FC<BrowseServiceSelectProps> = ({ value, onChange }) => {
  const intl = useIntl();
  const selectId = useId();
  return (
    <label htmlFor={selectId} className={clsx(styles.dropdown, value !== undefined && styles.dropdownSet)}>
      <span>{intl.formatMessage(messages.serviceLabel)}</span>
      <select
        id={selectId}
        className={styles.select}
        value={value ?? ''}
        onChange={(event) => onChange(event.target.value === '' ? undefined : event.target.value)}
        data-testid="browse-service"
      >
        <option value="">{intl.formatMessage(messages.serviceAll)}</option>
        {BROWSE_SERVICE_OPTIONS.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </label>
  );
};

export const BrowseServiceSelect = TypedMemo(BrowseServiceSelectComponent);
